// Actions
export const ALIBI_FETCH  = '[Alibi] Fetch'

// Mutations
export const ALIBI_META   = '[Alibi] meta'
export const ALIBI_OBTAIN = '[Alibi] obtain'
export const ALIBI_CLEAR  = '[Alibi] clear'
export const ALIBI_SET_LOADING = '[Alibi] set loading'
